<span [class]="'status ' + fromState(state)"
      [class._pulse]="pulse">
    <ng-content></ng-content>
    <small class="status-date" *ngIf="date" [innerHTML]="date"></small>
</span>
